// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35TQj","content":"styles_content__2cP5N"};